import { useContext } from "react";

import debug from "debug";

import { ConsumablesProductDetailsContext } from "./ConsumablesProductDetailsProvider";

const log = debug("desjti:ConsumablesProductDetailsProvider:useConsumablesProductDetailsContext");

export const useConsumablesProductDetailsContext = () => {
  const context = useContext(ConsumablesProductDetailsContext);

  if (!context) {
    const errorMessage = "useConsumablesProductDetailsContext hook used outside of ConsumablesProductDetailsProvider";
    log(errorMessage);
    throw new Error(errorMessage);
  }

  return context;
};
